import React from 'react';
import styled, { css } from 'styled-components';
import { DEVICE_SIZE, mq } from '../utils/mq';

export interface TableProps {
  data?: Row[];
}

export interface Row {
  label: string;
  value: any;
  url?: string;
  postLabel?: string;
}

const Tab = styled.table`
  font-size: 16px;
  margin: 0 0 15px;
  width: 100%;
`;

const TabRow = styled.tr`
  border-bottom: solid 1px #dddddd;
  display: flex;
  flex-direction: column;

  &:last-of-type {
    border-bottom: none;
  }

  ${mq.gte(
    DEVICE_SIZE.LARGE,
    css`
      display: table-row;
    `,
  )}
`;

const Label = styled.td`
  font-size: 12px;
  padding: 10px 0 3px;

  ${mq.gte(
    DEVICE_SIZE.LARGE,
    css`
      font-size: 16px;
      padding: 15px 0;
      width: 360px;
    `,
  )}
`;

const Value = styled.td`
  padding: 0 0 10px;

  ${mq.gte(
    DEVICE_SIZE.LARGE,
    css`
      padding: 15px 0;
    `,
  )}
`;

export const TableSimple = (props: TableProps) => {
  const { data } = props;

  return (
    <Tab>
      <tbody>
        {data?.map((field, keyField) => {
          if (field?.value) {
            return (
              <TabRow key={keyField}>
                <Label>{field.label}</Label>
                <Value>
                  {field.url ? (
                    <a href={field.url}>
                      {field.value} {field?.postLabel}
                    </a>
                  ) : (
                    <>
                      {field.value} {field?.postLabel}
                    </>
                  )}
                </Value>
              </TabRow>
            );
          }

          return null;
        })}
      </tbody>
    </Tab>
  );
};
